import { createSlice } from '@reduxjs/toolkit';
import {
  readyActionHandler,
  pendingActionHandler,
  rejectActionHandler,
} from 'helpers/sliceHelpers';
import { DATA_UNDEFINED, NO_ERRORS } from 'consts/xhr';
import { NO_CURRENT_ENTITY } from 'consts/store';
import { REDUCER_KEY } from './campaigns.consts';
import adapter from './campaigns.adapter';
import {
  fetchAll,
  fetchById,
  create,
  update,
  updateBudget,
  remove,
  deploy,
  setCurrent,
  toggleStatus,
  fetchBudget,
  updateStatus,
  updateOwner,
} from './campaigns.actions';

const slice = createSlice({
  name: REDUCER_KEY,
  initialState: {
    ...adapter.getInitialState(),
    status: DATA_UNDEFINED,
    errors: NO_ERRORS,
    current: NO_CURRENT_ENTITY,
    campaignInfo: {},
    isAdded: false,
  },
  reducers: {
    updateCampaignInfo: (state, action) => {
      state.campaignInfo = action.payload;
    },
    clearCampaignInfo: state => {
      state.campaignInfo = {};
    },
    setAdded: state => {
      state.isAdded = true;
    },
    clearAdded: state => {
      state.isAdded = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAll.fulfilled, (state, action) =>
        adapter.upsertMany(state, action.payload),
      )
      .addCase(fetchById.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(create.fulfilled, (state, action) =>
        adapter.addOne(state, action.payload),
      )
      .addCase(update.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(updateStatus.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(updateOwner.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(fetchBudget.fulfilled, (state, action) =>
        adapter.updateOne(state, action.payload),
      )
      .addCase(updateBudget.fulfilled, (state, action) =>
        adapter.updateOne(state, action.payload),
      )
      .addCase(remove.fulfilled, (state, action) =>
        adapter.removeOne(state, action.payload),
      )
      .addCase(deploy.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(setCurrent.pending, (state, action) => {
        state.current = action.meta.arg;
      })
      .addCase(setCurrent.fulfilled, (state, action) => {
        state.current = action.payload?.id || NO_CURRENT_ENTITY;
        if (action.payload) adapter.upsertOne(state, action.payload);
      })
      .addCase(toggleStatus.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(REDUCER_KEY + '/removeAll', state => adapter.removeAll(state))
      .addMatcher(
        ({ type }) =>
          type.startsWith(REDUCER_KEY) && type.endsWith('fulfilled'),
        readyActionHandler,
      )
      .addMatcher(
        ({ type }) => type.startsWith(REDUCER_KEY) && type.endsWith('pending'),
        pendingActionHandler,
      )
      .addMatcher(
        ({ type }) => type.startsWith(REDUCER_KEY) && type.endsWith('rejected'),
        rejectActionHandler,
      );
  },
});

export const {
  updateCampaignInfo,
  clearCampaignInfo,
  setAdded,
  clearAdded,
} = slice.actions;
export const { reducer } = slice;
